export default  class AuthService {
    static get $inject() {
        return [
            // Angular providers
            '$http', '$q', '$base64', '$httpParamSerializerJQLike',
            // App providers
            'ApiService', 'CookiesService'
        ];
    }

    constructor($http, $q, $base64, $httpParamSerializerJQLike,
                ApiService, CookiesService) {

        const APP_CLIENT_ID = 'qWsIDpwY7kLqdbVjfZtadmTJsmWaUu3ShtTDiDPL',
            APP_CLIENT_SERCRET = 'JmXTMwJi8YVzOg9OwsqaZ1DQQAd4TaqrPuFT1GCtM156Go7F5a4tlZO27AF74wdQt000PiUo4L1FzR2NYKEZ7bxJJIKNbOrDAqe1AKHFEmSA3mRDEfRyhVo0jA5brkhr';

        this.$http = $http;
        this.$q = $q;
        this.$base64 = $base64;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;

        this.CookiesService = CookiesService;
        this.ApiService = ApiService;

        this._client_id = APP_CLIENT_ID;
        this._client_secret = APP_CLIENT_SERCRET;

    }

    doLogin(response) {
        let result = response.data,
            token = result.access_token;

        /* Save token on client-side,
         it will be attach to all http requests to ensure authorization */
        this.CookiesService.setCookie('token', token);
    }

    login(userData) {
        let url = this.ApiService.api + '/o/token/',
            encoded = this.$base64.encode(this._client_id + ':' + this._client_secret);

        return this.$http.post(url, this.$httpParamSerializerJQLike({
            username: userData.email,
            password: userData.password,
            grant_type: 'password'
        }), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Basic ' + encoded
            }
        })
            .then(this.doLogin.bind(this))
            .catch(function (err) {
                //console.log(err.data);
                throw err.data.error_description;
            });
    }

    logout(callback) {
        return this.$http.post(this.ApiService.api + '/auth/logout/')
            .then(() => {
                this.CookiesService.removeCookie('token');
                if (angular.isFunction(callback)) {
                    callback();
                }
            });
    }

    forgotPassword(email) {
        return this.$http.post(this.ApiService.api + '/auth/password/reset/', {email: email});
    }

    resetPassword(data) {
        return this.$http.post(this.ApiService.api + '/auth/password/reset/confirm/', data);
    }

    validate(data) {
        return this.$http.post(this.ApiService.api + '/personal/access/panel/validate', data);
    }

    createAccount(data) {
        return this.$http.post(this.ApiService.api + '/auth/registration/', data);
    }

    ensureUnique(email) {
        return this.$http.post(this.ApiService.api + '/auth/local/ensureUnique', {email: email});
    }

    verifyEmail(token) {
        return this.$http.post(this.ApiService.api + '/auth/registration/verify-email/', {key: token}).then(() => true)
            .catch(() => false);
    }

};



/** WEBPACK FOOTER **
 ** ./src/services/auth/auth.service.js
 **/